import { signOut } from "firebase/auth";
import { useIdleTimer } from "react-idle-timer";
import { useAuth } from "./auth/auth-context/auth-context";
import { auth } from "./auth/config";
import { KioskRoutes } from "./components/routing/kiosk-routes";
import { WebRoutes } from "./components/routing/web-routes";
import { useKiosk } from "./kiosk/kiosk-context";

function App() {
  const { user } = useAuth();
  const { isKiosk } = useKiosk();

  const onIdle = () => {
    void signOut(auth);
  };

  useIdleTimer({
    onIdle,
    timeout: 1000 * 60 * 10,
    disabled: isKiosk || !user,
  });

  return <div>{isKiosk ? <KioskRoutes /> : <WebRoutes />}</div>;
}

export default App;
